import { MathUtils } from "@/lib/main";
import { DonutChartItemPropTypes } from "@/lib/types/visualizations/charts/DonutChart.types";
import DonutChartDonut from "./DonutChartDonut";
import DonutChartPie from "./DonutChartPie";

export default function DonutChartItem({
  size,
  donutLabel,
  blueValue,
  yellowValue,
  greenValue,
  redValue,
}: DonutChartItemPropTypes) {
  const total = MathUtils.safeAdd(blueValue, yellowValue, greenValue, redValue);

  const chartContainerStyle: React.CSSProperties = {
    position: "relative",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    gap: "var(--spacing-lg)",
    maxWidth: "100%",
  };

  return (
    <div style={chartContainerStyle}>
      <DonutChartPie
        size={size}
        total={total}
        blueValue={blueValue}
        yellowValue={yellowValue}
        greenValue={greenValue}
        redValue={redValue}
      />

      <DonutChartDonut size={size} donutLabel={donutLabel} total={total} />
    </div>
  );
}
